import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexGrid,
  ApexMarkers
} from "ng-apexcharts";


export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  colors: string[];
  yaxis: ApexYAxis;
  grid: ApexGrid;
  legend: ApexLegend;
  title: ApexTitleSubtitle;
};

@Component({
  selector: 'app-credit-history-chart',
  templateUrl: './credit-history-chart.component.html',
  styleUrls: ['./credit-history-chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CreditHistoryChartComponent implements OnInit {

  @ViewChild("chart") chart: ChartComponent | undefined;
  public chartOptions: Partial<ChartOptions> | any;
  historicalScores: any[] = [];

  labelColor: string = '';


  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.historicalScores = [
      { score: 650, calculation_date: '2025-01-10' },
      { score: 660, calculation_date: '2025-02-15' },
      { score: 670, calculation_date: '2025-03-20' },
      { score: 685, calculation_date: '2025-04-25' },
      { score: 700, calculation_date: '2025-05-30' },
      { score: 710, calculation_date: '2025-06-15' },
      { score: 720, calculation_date: '2025-07-05' },
      { score: 730, calculation_date: '2025-08-18' },
      { score: 740, calculation_date: '2025-09-22' },
      { score: 750, calculation_date: '2025-10-01' }
    ];
    const score = this.historicalScores.map(s => s.score);

    //Format date as "Mon YYYY" (e.g. "Jan 2024")
    const month = this.historicalScores.map(s => {
      const date = new Date(s.calculation_date);
      return new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(date);
    });

    this.chartOptions = {
      series: [
        {
          name: "Score",
          data: score
        }
      ],
      chart: {
        height: 249,
        background: 'transparent',
        type: "area",
        events: {
          click: (event: any, chartContext: any, config: any) => {
            // let score;
            // score = config.config.series[config.seriesIndex].data[config.dataPointIndex];
            // const scoreIndex = config.dataPointIndex;
            //  this.scoreAtIndex = this.historicalScores[scoreIndex];
            //  this.cdr.detectChanges();
          }
        },
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: "smooth"
      },
      fill: {
        type: 'solid',            // disables gradient
        opacity: 1
      },
      grid: {
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5
        },
        column: {
          colors: ['#f3f3f3', 'transparent'],
          opacity: 0.5
        }
      },
      markers: {
        size: 6,
        colors: ['#0057FF'],
        strokeColors: '#ffffff',
        strokeWidth: 2,
      },
      xaxis: {
        axisBorder: { show: true },
        axisTicks: { show: true },
        crosshairs: {
          show: true,
          width: 1,
          position: 'back',
          opacity: 1,
          stroke: { color: '#b6b6b6', dashArray: 0 }
        },
        categories: month,
        labels: {
          rotate: 0,
          formatter: (val: string) => {
            if (!val) return '';
            const [month, year] = val.split(' ');
            // const month = parts[0] || '';
            // const year = parts[1] || '';
            return [month, year];
          },
        }
      },
      yaxis: {
        crosshairs: { show: false }
      },

    };
  }

  reasonsList = [
    "Total amount owed in the most recent available month",
    "Length of time in business under present management",
    "Limited business activity signals reported in the past 12 months"
  ];

}
